import React, { useState, useEffect } from 'react'
import MediaLoad from '../../../media-load/MediaLoad';
import Input from '../../../input/Input';
import Select from './../../../select/Select';

let validateNumber = 0;
const Video = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ error, setErrors ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    
    useEffect(() => {
        if(!load && !props.edit) {
            props.onChange({
                ytUrl: '',
                poster: '',
                header: '',
                dark: 'false',
            }, props.index);
            setLoad(true);
        }
        if(!load) {
            validateNumber = props.validate;
        }
    }, [load])

    useEffect(() => {
        if(!load && props.edit) {
            if(!props.data || Object.keys(props.data).length == 0) {
                props.onChange({
                    ytUrl: '',
                    poster: '',
                    header: '',
                    dark: 'false',
                }, props.index);
            }
            setLoad(true);
        }
    }, [load])

    useEffect(() => {
        if(props.validate !== validateNumber) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const updateFields = (val, label) => {
        let newData = props.data;
        newData[label] = val;
        saveData(newData);
    }

    const saveData = (data) => {
        props.onChange({
            ...data
        }, props.index);
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.video-${props.index} .error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const options = [
        {
            value: "false",
            text: "Wyłączone"
        },
        {
            value: "true",
            text: "Włączone"
        },
    ]

    return (
        <div className={error ? `section-wrapper video error-section video-${props.index}` : `section-wrapper video video-${props.index}`}>
            <div className="section-items">
                <div className="row-section">
                    <Input  required={ false }
                        setFunction={ val => updateFields(val, 'header') }
                        value={props.data.header}
                        label={ 'Nagłówek' }
                        regExp={ /.*/ }
                        minChar={ 3 } 
                        forceValidate={ forceValidate } 
                    />
                </div>
                <div className="row-section">
                    <Input  required={ true }
                        setFunction={ val => updateFields(val, 'ytUrl') }
                        value={props.data.ytUrl}
                        label={ 'Link youtube' }
                        regExp={ /.*/ }
                        minChar={ 3 } 
                        forceValidate={ forceValidate } 
                    />
                </div>
                <div className="row-section">
                    <Select name="dark"
                        data={ options } 
                        label="Przyciemnienie"
                        value={ String(props.data.dark) }
                        handle={ (val) => updateFields(val, 'dark') } 
                        class="btn-primary btn-simple" />
                </div>
                <div className="row-section">
                    <MediaLoad forceValidate={ forceValidate } setFunction={ val => updateFields(val, 'poster') } value={props.data.poster} label="Poster" />
                </div>
            </div>
        </div>
    );
}

export default Video;